import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Landmark, FileText } from "lucide-react";

export default function CorporateCompliance() {
  const [data, setData] = useState({ companies: [], llp: [] });
  useEffect(() => { api.get("/corporate-compliance/deadlines").then((r) => setData(r.data)); }, []);

  const FormsGrid = ({ forms, kind }) => (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
      {forms.map((f) => (
        <Card key={f.form} className="p-4 rounded-sm hover:border-accent transition-colors" data-testid={`form-${kind}-${f.form.replace(/[^a-z0-9]/gi, '')}`}>
          <div className="flex items-start justify-between">
            <FileText className="w-5 h-5 text-accent" />
            <span className="text-[10px] font-mono uppercase bg-amber-100 text-amber-700 px-2 py-0.5 rounded-sm">Phase 3b</span>
          </div>
          <div className="mt-3 font-heading font-semibold">{f.form}</div>
          <div className="text-xs text-muted-foreground mt-1">{f.purpose}</div>
          <div className="text-[11px] text-accent mt-2 font-mono">Due: {f.due}</div>
          <Button size="sm" variant="outline" className="rounded-sm mt-3 w-full" onClick={() => {
            const map = { "MGT-7 / 7A": "mgt-7", "AOC-4": "aoc-4", "DPT-3": "dpt-3", "Form 8": "form-8",
                            "FLA Return": "FLA", "DIR-3 KYC": "DIR-3-KYC", "MSME-1": "MSME-1",
                            "BEN-2": "BEN-2", "ADT-1": "ADT-1", "INC-20A": "INC-20A", "PAS-6": "PAS-6",
                            "Form 11": "LLP-11" };
            const slug = map[f.form];
            if (slug) window.location.href = `/app/corporate-compliance/${slug}`;
          }}>Open wizard →</Button>
        </Card>
      ))}
    </div>
  );

  return (
    <div className="p-6 lg:p-8 space-y-6" data-testid="corporate-compliance-page">
      <PageHeader eyebrow="Regulatory" title="Corporate Compliance"
        description="Companies Act 2013 + LLP Act 2008 filings — each form has an input wizard, PDF preview, and JSON/XML export for the MCA portal." />
      <Tabs defaultValue="company">
        <TabsList className="rounded-sm">
          <TabsTrigger value="company" className="rounded-sm" data-testid="cc-tab-company">Companies Act (10)</TabsTrigger>
          <TabsTrigger value="llp" className="rounded-sm" data-testid="cc-tab-llp">LLP Act (5)</TabsTrigger>
          <TabsTrigger value="calendar" className="rounded-sm">Deadline Calendar</TabsTrigger>
        </TabsList>
        <TabsContent value="company" className="mt-4"><FormsGrid forms={data.companies} kind="co" /></TabsContent>
        <TabsContent value="llp" className="mt-4"><FormsGrid forms={data.llp} kind="llp" /></TabsContent>
        <TabsContent value="calendar" className="mt-4">
          <Card className="p-8 rounded-sm text-center text-muted-foreground">
            <Landmark className="w-10 h-10 mx-auto opacity-40 mb-3" />
            Every MCA deadline in a single calendar view — email + WhatsApp reminders. Wiring up in the next sprint.
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
